import { isMilitaryUnit } from './pbgidIcons'

export function filterOutEconomy(squads, pbgidIcons) {
	if (!squads) return []
	return squads.filter((squad) => isMilitaryUnit(pbgidIcons, squad))
}

export function getCombinedCount(data, ids) {
	return (data ?? []).reduce((total, item) => {
		if (ids.includes(item.pbg_id)) {
			total += item.count
		}
		return total
	}, 0)
}

export function getFrequencyCount(data, ids) {
	return (data ?? []).reduce((count, item) => {
		if (ids.includes(item.pbg_id) && (item.building_progress === undefined || item.building_progress === 1)) {
			count++
		}
		return count
	}, 0)
}
